import React from "react";

const InputRequire = () => {
  return (
    <>
      <strong className="text-danger">*</strong>
    </>
  );
};

export default InputRequire;
